export const FEATURE_NAME = '@vshosting/cdn/core/settings-base';
